import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
  drivers,
  driverActiveStatus,
}) => {
  // Find driver name by ID
  const getDriverName = (driverId) => {
    if (!driverId) return "";
    const driver = drivers.find(
      (d) => String(d.driver_id) === String(driverId)
    );
    return driver ? driver.full_name : driverId;
  };

  // Find active status name by ID
  const getActiveStatusName = (statusId) => {
    if (!statusId) return "";
    const status = driverActiveStatus.find((s) => s.id === statusId);
    return status ? status.name : statusId;
  };

  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "driver_id",
      label: "Driver",
      value: getDriverName(submittedData.driver_id),
    },
    {
      type: "standard",
      id: "fullName",
      label: "Full Name",
      value: submittedData.fullName,
    },
    {
      type: "standard",
      id: "active_driver",
      label: "Is Active",
      value: getActiveStatusName(submittedData.active_driver),
    },
    {
      type: "dateRange",
      id: "date",
      label: "Date Range",
      startValue: submittedData.start_date,
      endValue: submittedData.end_date,
      startField: "start_date",
      endField: "end_date",
    },
  ];

  const handleRemoveDateRange = (field) => {
    handleRemove(field);
  };

  return (
    <>
      <Grid item xs={12} sx={{ mb: filterOpen ? 2 : 0 }}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
                drivers={drivers}
                driverActiveStatus={driverActiveStatus}
              />
            </Box>
          </Card>
        </Collapse>
      </Grid>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveFilter={handleRemove}
      />
    </>
  );
};

export default Filter;
